import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider as JotaiProvider } from 'jotai';

// Arquivos agora realmente existentes
import "source-sans-pro/source-sans-pro.css"; 
import "normalize.css/normalize.css";

window.React = React;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <JotaiProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </JotaiProvider>
  // </React.StrictMode>
);

serviceWorker.unregister();